module.exports = __webpack_public_path__ + "static/media/ios-time.215ddf1e.svg";